import c0 from './layout/notification_component_controller';
import c1 from './chart/pie_chart_component_controller';
import c2 from './chart/scatter_chart_component_controller';
import c3 from './chart/bar_chart_component_controller';
import c4 from './chart/sankey_chart_component_controller';
import c5 from './chart/growth_share_matrix_component_controller';
import c6 from './chart/gauge_chart_component_controller';
import c7 from './chart/bar_line_chart_component_controller';
import c8 from './chart/line_chart_component_controller';
import c9 from './chart/base_chart_component_controller';
import c10 from './chart/waterfall_chart_component_controller';
import c11 from './chart/xy_chart_component_controller';
import c12 from './common/carousel_component_controller';
import c13 from './common/tabs_component_controller';
import c14 from './common/marquee_component_controller';
import c15 from './common/map_component_controller';
import c16 from './dashboard/offers/chart_component_controller';
export const definitions = [
	{identifier: 'layout--notification-component', controllerConstructor: c0},
	{identifier: 'chart--pie-chart-component', controllerConstructor: c1},
	{identifier: 'chart--scatter-chart-component', controllerConstructor: c2},
	{identifier: 'chart--bar-chart-component', controllerConstructor: c3},
	{identifier: 'chart--sankey-chart-component', controllerConstructor: c4},
	{identifier: 'chart--growth-share-matrix-component', controllerConstructor: c5},
	{identifier: 'chart--gauge-chart-component', controllerConstructor: c6},
	{identifier: 'chart--bar-line-chart-component', controllerConstructor: c7},
	{identifier: 'chart--line-chart-component', controllerConstructor: c8},
	{identifier: 'chart--base-chart-component', controllerConstructor: c9},
	{identifier: 'chart--waterfall-chart-component', controllerConstructor: c10},
	{identifier: 'chart--xy-chart-component', controllerConstructor: c11},
	{identifier: 'common--carousel-component', controllerConstructor: c12},
	{identifier: 'common--tabs-component', controllerConstructor: c13},
	{identifier: 'common--marquee-component', controllerConstructor: c14},
	{identifier: 'common--map-component', controllerConstructor: c15},
	{identifier: 'dashboard--offers--chart-component', controllerConstructor: c16},
];
